import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type CommunicationRoutes = {
    communication: Route
}

export const communicationRoutes: CommunicationRoutes = {
    communication: {
        path: 'dashboard/communication',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.communication.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-communication/page-communication.component').then(
                (m) => m.PageCommunicationComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Default) },
    },
}
